package antd.select

import kotlinext.js.jsObject
import react.RBuilder
import react.RHandler

inline fun <T : SelectValue, reified SC : SelectComponent<T>> RBuilder.select(noinline handler: RHandler<SelectProps<T>>) = child(SC::class, handler)
inline fun <T : SelectValue, reified SC : MultiSelectComponent<T>> RBuilder.multiSelect(noinline handler: RHandler<MultiSelectProps<T>>) = child(SC::class, handler)

fun RBuilder.option(handler: RHandler<OptionProps>) = child(OptionComponent::class, handler)
fun RBuilder.optGroup(handler: RHandler<OptionGroupProps>) = child(OptionGroupComponent::class, handler)
